
import { Component, Vue } from 'vue-property-decorator';
import { Action } from 'vuex-class';
import { writeCookie, getQueryString } from '@/tools/tools';

@Component({
  components: {}
})
export default class extends Vue {
  @Action('user/setUserInfoList') setUserInfoList!: Function

  created() {
    this.getAppLoginInfor();
  }

  // 获取app登录信息并存起来
  private async getAppLoginInfor() {
    if (getQueryString('equipMeid')) {
      const anchorobj = {
        accessToken: getQueryString('token'),
        equip: getQueryString('equip'),
        equipMeid: getQueryString('equipMeid'),
        equipVersion: getQueryString('equipVersion'),
        model: getQueryString('model'),
        version: getQueryString('version'),
        macCode: getQueryString('macCode'),
        src: getQueryString('src'),
        languageType: getQueryString('language')
      };
      if (getQueryString('token')) {
        writeCookie('accessToken', getQueryString('token'));
        await this.setUserInfoList();
      }
      writeCookie('anchor', anchorobj);
    }
  }
}
